<template>
<w-sliding-popup ref="slidingPopup" width="700px" title="SQL 설정" class="sql-setting-popup" :defaultContent="false">
  <div slot="content" style="height: 100%;padding: 25px 40px 25px 25px;">
    <div v-show="currentViewType == 'mainView'" style="height: 100%;">
      <div style="height: calc(50% - 10px); margin-bottom: 20px;">
        <el-row class="title-bar">
          <div class="vertical-center-box">
            <div class="title-h3 mr-r15">DB 목록</div>
            <div class="setting-addel">
              <el-button size="mini" @click="onDbInfoAddClick"><i class="fas fa-plus"/></el-button>
              <el-button size="mini" @click="onDbInfoDeleteClick" :disabled="dbInfoSelectData===null"><i class="fas fa-minus" /></el-button>
            </div>
          </div>
        </el-row>
        <div class="table-wrapper">
          <el-table class="popup" :data="dbInfo" :highlight-current-row="true" @current-change="onDbInfoSelect" @row-dblclick="onDbInfoDblClick" style="width: 100%;" row-class-name="c-dblclick">
            <el-table-column prop="dbId" label="DB 명" width="180px" headerAlign="left"></el-table-column>
            <el-table-column prop="dbType" label="DB Type" width="100px" headerAlign="left"></el-table-column>
            <el-table-column prop="dbUrl" label="DB URL" headerAlign="left"></el-table-column>
          </el-table>
        </div>
      </div>
      <div style="height: calc(50% - 10px);">
        <el-row class="title-bar">
          <div class="vertical-center-box">
            <div class="title-h3 mr-r15">SQL 목록</div>
            <div class="setting-addel">
              <el-button size="mini" @click="onSqlInfoAddClick"><i class="fas fa-plus"/></el-button>
              <el-button size="mini" @click="onSqlInfoDeleteClick" :disabled="sqlInfoSelectData===null"><i class="fas fa-minus" /></el-button>
            </div>
          </div>
        </el-row>
        <div class="table-wrapper">
          <el-table class="popup" :data="sqlInfo" :highlight-current-row="true" @current-change="onSqlInfoSelect" @row-dblclick="onSqlInfoDblClick" style="width: 100%;" row-class-name="c-dblclick">
            <el-table-column prop="queryId" label="SQL 명" width="150px" headerAlign="left"></el-table-column>
            <el-table-column prop="dbId" label="DB 명" width="180px" headerAlign="left"></el-table-column>
            <el-table-column prop="resultvalueType" label="결과 타입" width="100px" headerAlign="left"></el-table-column>
            <el-table-column prop="checkDatetime" label="마지막 수행시각" headerAlign="left" align="left" :formatter="dateFormatter"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div v-show="currentViewType == 'subView'" style="height: 100%;">
      <component :is="subViewComponent" ref="subView" :setting-type="settingType" @change-current-view-type="changeCurrentViewType" @loadData="loadData"></component>
    </div>
  </div>
  <div slot="footer">
    <el-row type="flex" justify="center" align="middle" v-show="currentViewType == 'subView'" :gutter="10">
      <el-button class="mr-r4" size="large" type="solid" @click="save">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </el-row>
    <el-row type="flex" justify="center" align="middle" v-show="currentViewType == 'mainView'">
      <el-button size="large" type="solid" @click="close">닫기</el-button>
    </el-row>
  </div>
</w-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import SqlAPI from '@/api/dashboard/sql';
import DashboardAPI from '@/api/dashboard/common';

import DashboardConst from '@/constants/dashboard';

import { isEmpty } from '@/utils/basic';
import isNil from 'lodash/isNil';
import find from 'lodash/find';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';

import WDbInfoSettingForm from '@/views/dashboard/components/form/DbInfoSettingForm';
import WSqlInfoSettingForm from '@/views/dashboard/components/form/SqlInfoSettingForm';

export default {
  name: 'WSqlSettingPopup',
  components: {
    WDbInfoSettingForm,
    WSqlInfoSettingForm,
  },
  data() {
    return {
      currentViewType: 'mainView',
      subViewComponent: null,
      settingType: '추가',
      dbInfoSelectData: null,
      sqlInfoSelectData: null,
      dbInfo: null,
      sqlInfo: null,
    };
  },
  computed: {
    iconStyle() {
      return 'margin-left: 5px; margin-bottom: 10px;';
    },
  },
  created() {
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.SQL_SETTING, this.open);
  },
  beforeDestroy() {
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.SQL_SETTING, this.open);
  },
  methods: {
    /**
     * DB정보, SQL정보 로드
     * @author JungJioon(ryunnnne)
     * @return {[type]} [description]
     */
    loadData() {
      SqlAPI.getDbInfo().then((response) => {
        this.dbInfo = response.data.data;
      });
      SqlAPI.getQueryInfo().then((response) => {
        this.sqlInfo = response.data.data;
      });
      DashboardAPI.getSqlInfo().then((response) => {
        this.$store.commit('setSqlInfo', response.data.data);
      });
    },
    /**
     * 팝업 데이터 초기화
     * @author JungJioon(ryunnnne)
     * @return {[type]} [description]
     */
    initData() {
      this.currentViewType = 'mainView';
      this.subViewComponent = null;
      this.settingType = '추가';
      this.dbInfoSelectData = null;
      this.sqlInfoSelectData = null;
      this.dbInfo = null;
      this.sqlInfo = null;
    },
    /**
     * 팝업 open 요펑
     * @author JungJioon(ryunnnne)
     * @return {[type]} [description]
     */
    open() {
      this.initData();
      this.loadData();
      this.$refs.slidingPopup.open();
    },
    /**
     * 팝업 close 요청
     * @author JungJioon(ryunnnne)
     * @return {[type]} [description]
     */
    close() {
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.DATABASE_SQL_LOAD);
      this.initData();
      this.$refs.slidingPopup.close();
    },
    /**
     * 저장버튼 클릭
     * @author JungJioon(ryunnnne)
     * @return {[type]} [description]
     */
    save() {
      const subView = this.$refs.subView;
      const formData = subView.getFormData();
      subView.$refs.form.validate((valid) => {
        if (valid) {
          switch (this.settingType) {
            case '추가': {
              const findItem = find((this.subViewComponent === 'WDbInfoSettingForm') ? this.dbInfo : this.sqlInfo, formData.data);
              if (!isNil(findItem)) {
                this.$message(msgUtil.getCustomMsgData(`같은 이름의 ${formData.name}이 존재합니다`));
              } else {
                subView.addInfo();
              }
              break;
            }
            case '수정': {
              subView.updateInfo();
              break;
            }
            default:
              break;
          }
          // this.$nextTick(() => {
          //   this.loadData();
          //   subView.onBackBtnClick();
          // });
        } else {
          this.$message(msgUtil.getCustomMsgData('올바른 정보를 입력해 주십시오.'));
        }
      });
    },
    /**
     * 팝업 뷰 변경
     * @author JungJioon(ryunnnne)
     * @param  {[type]} currentViewType  [description]
     * @param  {[type]} subViewComponent [description]
     * @return {[type]}                  [description]
     */
    changeCurrentViewType(currentViewType, subViewComponent) {
      this.currentViewType = currentViewType;
      this.subViewComponent = isEmpty(subViewComponent) ? null : subViewComponent;
    },
    /**
     * DB정보 추가 버튼 클릭
     * @author JungJioon(ryunnnne)
     * @return {[type]} [description]
     */
    onDbInfoAddClick() {
      this.currentViewType = 'subView';
      this.subViewComponent = 'WDbInfoSettingForm';
      this.settingType = '추가';
    },
    /**
     * DB정보 선택
     * @author JungJioon(ryunnnne)
     * @param  {[type]} currentRow [description]
     * @return {[type]}            [description]
     */
    onDbInfoSelect(currentRow) {
      this.dbInfoSelectData = currentRow;
    },
    /**
     * DB정보 더블클릭시 팝업 뷰 수정폼 변경
     * @author JungJioon(ryunnnne)
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    onDbInfoDblClick(row) {
      this.currentViewType = 'subView';
      this.subViewComponent = 'WDbInfoSettingForm';
      this.settingType = '수정';
      this.$nextTick(() => {
        const subView = this.$refs.subView;
        subView.setUpdateData(row);
      });
    },
    /**
     * DB정보 삭제 버튼 클릭
     * @author JungJioon(ryunnnne)
     * @return {[type]} [description]
     */
    onDbInfoDeleteClick() {
      if (isEmpty(this.dbInfoSelectData)) {
        this.$message(msgUtil.getCustomMsgData('삭제할 DB정보를 선택해주십시오.'));
      } else {
        SqlAPI.deleteDbInfo(this.dbInfoSelectData.dbId).then((response) => {
          const result = response.data;
          if (result.success) {
            this.$message({
              type: 'success',
              message: 'DB 정보를 삭제하였습니다.',
            });
            this.loadData();
          } else {
            this.$message({
              type: 'error',
              message: 'DB 정보 삭제를 실패했습니다.',
            });
          }
        });
      }
    },
    /**
     * SQL 추가 버튼 클릭
     * @author JungJioon(ryunnnne)
     * @return {[type]} [description]
     */
    onSqlInfoAddClick() {
      this.currentViewType = 'subView';
      this.subViewComponent = 'WSqlInfoSettingForm';
      this.settingType = '추가';
    },
    /**
     * SQL정보 선택
     * @author JungJioon(ryunnnne)
     * @param  {[type]} currentRow [description]
     * @return {[type]}            [description]
     */
    onSqlInfoSelect(currentRow) {
      this.sqlInfoSelectData = currentRow;
    },
    /**
     * SQL정보 더블클릭시 팝업 뷰 수정폼 변경
     * @author JungJioon(ryunnnne)
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    onSqlInfoDblClick(row) {
      this.currentViewType = 'subView';
      this.subViewComponent = 'WSqlInfoSettingForm';
      this.settingType = '수정';
      this.$nextTick(() => {
        const subView = this.$refs.subView;
        subView.setUpdateData(row);
      });
    },
    /**
     * SQL 삭제 버튼 클릭
     * @author JungJioon(ryunnnne)
     * @return {[type]} [description]
     */
    onSqlInfoDeleteClick() {
      if (isEmpty(this.sqlInfoSelectData)) {
        this.$message(msgUtil.getCustomMsgData('삭제할 SQL정보를 선택해주십시오.'));
      } else {
        SqlAPI.deleteQueryInfo(this.sqlInfoSelectData.queryId).then((response) => {
          const result = response.data;
          if (result.success) {
            this.$message({
              type: 'success',
              message: 'SQL 정보를 삭제하였습니다.',
            });
            this.loadData();
          } else {
            this.$message({
              type: 'error',
              message: 'SQL 정보 삭제를 실패했습니다.',
            });
          }
        });
      }
    },
    dateFormatter(row, column, cellValue) {
      if (!isNil(cellValue)) {
        return getDateToString(cellValue);
      }
      return EMPTY_TEXT;
    },
  },
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/popup/SqlSettingPopup.vue